import type { Theme } from '@mui/material';

import type { LiteralNumberUnion, LiteralUnion } from 'types';

const TRANSITION_MAP = {
  short: 150,
  medium: 225,
  long: 300,
};

type TransitionDuration = keyof typeof TRANSITION_MAP;

function isTransitionDuration(
  duration?: LiteralNumberUnion<TransitionDuration> | LiteralUnion<TransitionDuration>,
): duration is TransitionDuration {
  return typeof duration === 'string' && ['short', 'medium', 'long'].includes(duration);
}

type CreateTransitionOptions = {
  /**
   * Defines the transitioned styles
   *
   * @default 'all'
   */
  props?: string | string[];

  /**
   * Defines duration of transition
   *
   * @default 'medium'
   */
  duration?: LiteralNumberUnion<TransitionDuration> | LiteralUnion<TransitionDuration>;

  /**
   * Defines the easing style
   */
  easing?: string;

  /**
   * Defines the transition delay
   */
  delay?: number | string;
};

export function createTransition(
  theme: Theme,
  { props = 'all', duration = 'medium', ...options }: CreateTransitionOptions = {},
) {
  if (isTransitionDuration(duration)) {
    return theme.transitions.create(props, { ...options, duration: TRANSITION_MAP[duration] });
  }

  return theme.transitions.create(props, { ...options, duration });
}
